module.exports = __webpack_public_path__ + "static/media/message.4d43551f.svg";